import React, {Component} from 'react';
import {Form} from 'react-redux-form';
import RequiredInput from '../../../../common/form/elements/required-input';
import MultiSelect from '../../../../common/form/multi-select';
import PushNotificationTiming from './push-notification-timing';
import Button from '../../../../common/button';
import RequiredSelect from '../../../../common/form/elements/required-select';
import Can from '../../../../common/guards/can';


class PushNotificationForm extends Component {
  createGroupList = (groups) => {
    const grps = groups.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

    return grps;
  };

  render() {
    const {
      onPushSave, onTemplateSave, model, invalid, pages,
      groups, formData
    } = this.props;

    return (
      <div className="mg-top-30">
        <Form model={model} onSubmit={() => false}>
          <RequiredInput model=".title" label="Title" placeholder="Title"/>
          <RequiredInput model=".content" label="Content" placeholder="Content"/>

          <RequiredSelect label="Page" model={`${model}.page`} values={pages}/>

          <MultiSelect
            model={`${model}.group_ids`}
            data={this.createGroupList(groups) || []}
            label="Groups"
            value={formData.group_ids}
            controlId="groups"
          />

          <PushNotificationTiming formModel={model}/>

          <div className="pull-right">
            <div style={{display: 'inline-block'}}>
              <Can subjectClass="PushNotification" action="add">
                <Button
                  className="form-inline"
                  onClick={onPushSave}
                  disabled={invalid}
                  submit
                  inline
                >
              Push
                </Button>
              </Can>
            </div>
            <div style={{display: 'inline-block'}}>
              <Can subjectClass="PushNotificationTemplate" action="add">
                <Button
                  onClick={onTemplateSave}
                  disabled={invalid}
                  inline
                >
                Save to templates
                </Button>
              </Can>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default PushNotificationForm;



// WEBPACK FOOTER //
// ./src/components/admin/app/push-notifications/templates/push-notification-form.jsx